import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=34ae88b4&scoped=true&"
import script from "./BannerCard.vue?vue&type=script&lang=js&"
export * from "./BannerCard.vue?vue&type=script&lang=js&"
import style0 from "./BannerCard.vue?vue&type=style&index=0&id=34ae88b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae88b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ae88b4')) {
      api.createRecord('34ae88b4', component.options)
    } else {
      api.reload('34ae88b4', component.options)
    }
    module.hot.accept("./BannerCard.vue?vue&type=template&id=34ae88b4&scoped=true&", function () {
      api.rerender('34ae88b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/BannerCard.vue"
export default component.exports